module.exports = __webpack_public_path__ + "static/img/23-2.6458993.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/23-2.jpg
// module id = rJuy
// module chunks = 0